// Company job table names - now that migration is complete, these are the actual table names
// No more 'as any' needed since the tables exist with these exact names

export const TABLE_NAMES = {
  // Core job tables
  JOB_POSTINGS: 'company_job_postings',
  JOB_APPLICATIONS: 'company_job_applications',
  JOB_PERMISSIONS: 'company_job_permissions',
  JOB_TEAM_INVITATIONS: 'company_job_team_invitations',
  
  // Pipeline tables
  JOB_PIPELINE_STAGE_HISTORY: 'company_job_pipeline_stage_history',
  
  // Interview tables
  JOB_AI_INTERVIEW_QUESTIONS: 'company_job_ai_interview_questions',
  JOB_AI_INTERVIEW_RESULTS: 'company_job_ai_interview_results',
  JOB_AI_INTERVIEW_SESSIONS: 'company_job_ai_interview_sessions',
  JOB_AI_INTERVIEW_TRANSCRIPTS: 'company_job_ai_interview_transcripts',
  JOB_AI_INTERVIEW_EVALUATIONS: 'company_job_ai_interview_evaluations',
  
  // Assessment tables
  JOB_RESUME_EVALUATIONS: 'company_job_resume_evaluations',
  JOB_QUIZ_SESSIONS: 'company_job_quiz_sessions',
  JOB_CUSTOM_ASSIGNMENTS: 'company_job_custom_assignments',
  JOB_ASSESSMENT_RESULTS: 'company_job_assessment_results',
  
  // File and analytics tables
  JOB_APPLICATION_FILES: 'company_job_application_files',
  JOB_VIEW_ANALYTICS: 'company_job_view_analytics',
  JOB_QUALITY_METRICS: 'company_job_quality_metrics',
  JOB_EMBEDDINGS: 'company_job_embeddings',
  JOB_GENERATION_TASKS: 'company_job_generation_tasks',
  
  // Automation
  JOB_AUTOMATION_RULES: 'company_job_automation_rules',
  
  // LEGACY: Job-specific recruiter applications (deprecated - referral system doesn't require per-job approval)
  JOB_RECRUITER_APPLICATIONS: 'company_job_recruiter_applications',
  
  // Additional tables found in database
  JOB_EVALUATION_CALL_LOGS: 'company_job_evaluation_call_logs',
  JOB_EVALUATION_EVIDENCE_BUNDLES: 'company_job_evaluation_evidence_bundles',
  JOB_HIRING_REQUIREMENT: 'company_job_hiring_requirement',

  // Evee AI Chat tables
  EVEE_CHAT_THREADS: 'evee_chat_threads',
  EVEE_CHAT_MESSAGES: 'evee_chat_messages',

  // Nanny Platform tables
  USER_NANNY_PROFILES: 'user_nanny_profiles',
  USER_MOTHER_PROFILES: 'user_mother_profiles',
  NANNY_JOB_POSTINGS: 'nanny_job_postings',
  NANNY_JOB_APPLICATIONS: 'nanny_job_applications',
  NANNY_REVIEWS: 'nanny_reviews',
} as const;

// Type helper for table operations
export type TableName = typeof TABLE_NAMES[keyof typeof TABLE_NAMES];